<div class="contractor-report-container">
  <div class="report-header">
    <h1>承攬商績效報表</h1>
    <div class="filter-section">
      <div class="filter-item">
        <label for="category-filter">承攬商類別:</label>
        <select id="category-filter" [(ngModel)]="selectedCategory" (change)="updateFilter()">
          <option *ngFor="let cat of categories" [value]="cat">
            {{cat === 'all' ? '全部類別' : cat}}
          </option>
        </select>
      </div>
      <div class="filter-item">
        <label for="date-range-start">日期區間:</label>
        <div class="date-range-inputs">
          <input type="date" id="date-range-start" [(ngModel)]="dateRange.start" (change)="updateFilter()">
          <span>至</span>
          <input type="date" id="date-range-end" [(ngModel)]="dateRange.end" (change)="updateFilter()">
        </div>
      </div>
    </div>
  </div>

  <!-- 統計摘要區塊 -->
  <div class="summary-section">
    <div class="summary-card">
      <div class="summary-icon">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <div class="summary-content">
        <div class="summary-value">{{totalViolations}}</div>
        <div class="summary-label">總違規次數</div>
      </div>
    </div>

    <div class="summary-card">
      <div class="summary-icon">
        <i class="fas fa-door-open"></i>
      </div>
      <div class="summary-content">
        <div class="summary-value">{{totalEntries}}</div>
        <div class="summary-label">總進廠次數</div>
      </div>
    </div>

    <div class="summary-card">
      <div class="summary-icon">
        <i class="fas fa-shield-alt"></i>
      </div>
      <div class="summary-content">
        <div class="summary-value">{{avgSafetyScore}}</div>
        <div class="summary-label">平均安全評分</div>
      </div>
    </div>

    <div class="summary-card">
      <div class="summary-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="summary-content">
        <div class="summary-value">{{avgComplianceRate}}%</div>
        <div class="summary-label">平均合規率</div>
      </div>
    </div>
  </div>

  <!-- 主要圖表區域 -->
  <div class="charts-grid">
    <!-- 違規排行榜 -->
    <div class="chart-container">
      <div class="chart-header">
        <h2>承攬商違規排行榜</h2>
        <div class="chart-actions">
          <button class="info-button" title="顯示違規次數與嚴重程度排行">
            <i class="fas fa-info-circle"></i>
          </button>
        </div>
      </div>
      <div class="chart-body">
        <div #violationChart class="echart-container"></div>
      </div>
    </div>

    <!-- 進廠次數統計 -->
    <div class="chart-container">
      <div class="chart-header">
        <h2>進廠次數統計</h2>
        <div class="chart-actions">
          <button class="info-button" title="顯示進廠次數與登記人員數量">
            <i class="fas fa-info-circle"></i>
          </button>
        </div>
      </div>
      <div class="chart-body">
        <div #entryChart class="echart-container"></div>
      </div>
    </div>

    <!-- 安全評分 -->
    <div class="chart-container">
      <div class="chart-header">
        <h2>安全評分分布</h2>
        <div class="chart-actions">
          <button class="info-button" title="承攬商安全評分排行">
            <i class="fas fa-info-circle"></i>
          </button>
        </div>
      </div>
      <div class="chart-body">
        <div #safetyChart class="echart-container"></div>
      </div>
    </div>

    <!-- 合規率比較 -->
    <div class="chart-container">
      <div class="chart-header">
        <h2>合規率比較</h2>
        <div class="chart-actions">
          <button class="info-button" title="各承攬商合規率比較">
            <i class="fas fa-info-circle"></i>
          </button>
        </div>
      </div>
      <div class="chart-body">
        <div #complianceChart class="echart-container"></div>
      </div>
    </div>

    <!-- 績效雷達圖 -->
    <div class="chart-container full-width">
      <div class="chart-header">
        <h2>績效綜合比較</h2>
        <div class="chart-actions">
          <button class="info-button" title="顯示前三名承攬商的綜合績效比較">
            <i class="fas fa-info-circle"></i>
          </button>
        </div>
      </div>
      <div class="chart-body">
        <div #performanceChart class="echart-container"></div>
      </div>
    </div>

    <!-- 趨勢分析 -->
    <div class="chart-container full-width">
      <div class="chart-header">
        <h2>月度趨勢分析</h2>
        <div class="chart-actions">
          <button class="info-button" title="顯示違規、進廠與安全評分的月度趨勢">
            <i class="fas fa-info-circle"></i>
          </button>
        </div>
      </div>
      <div class="chart-body">
        <div #trendChart class="echart-container"></div>
      </div>
    </div>
  </div>

  <!-- 違規類別分析 -->
  <div class="violation-categories-section">
    <h2>違規類別分析</h2>
    <div class="category-bars">
      <div class="category-item" *ngFor="let category of getViolationCategories()">
        <div class="category-label">{{category.name}}</div>
        <div class="category-bar-container">
          <div class="category-bar" [style.width.%]="(category.count / getMaxViolationCount()) * 100"></div>
          <div class="category-count">{{category.count}}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- 承攬商詳細數據表 -->
  <div class="contractors-table-section">
    <div class="table-header">
      <h2>承攬商詳細績效數據</h2>
      <div class="table-actions">
        <button class="export-button">
          <i class="fas fa-file-export"></i> 導出報表
        </button>
      </div>
    </div>
    <div class="table-container">
      <table class="contractors-table">
        <thead>
          <tr>
            <th>承攬商名稱</th>
            <th>類別</th>
            <th>進廠次數</th>
            <th>違規次數</th>
            <th>安全評分</th>
            <th>合規率</th>
            <th>回應時間</th>
            <th>工作完成率</th>
            <th>準時率</th>
            <th>平均停留時間</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let contractor of getFilteredContractors()">
            <td>{{contractor.name}}</td>
            <td>{{contractor.category}}</td>
            <td>{{contractor.totalEntries}}</td>
            <td [class.highlight-warning]="contractor.violationsCount > 3">{{contractor.violationsCount}}</td>
            <td [ngClass]="getSafetyScoreClass(contractor.safetyScore)">{{contractor.safetyScore}}</td>
            <td>{{contractor.complianceRate}}%</td>
            <td>{{contractor.responseTime}}小時</td>
            <td>{{contractor.workCompletionRate}}%</td>
            <td>{{contractor.onTimeRate}}%</td>
            <td>{{contractor.avgStayHours}}小時</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
